import LeftSection from 'src/components/adminTeam/LeftSection';
import RightSection from 'src/components/adminTeam/RightSection';
import styled from 'styled-components';


const PageWrapper = styled.div`
  display: flex;
  gap: 22px;
  margin: 30px 30px;
  border-radius: 10px;
  height: calc(100vh - 126px); /* 필요시 조정 */
`;
const LeftSideWrapper = styled.div`
  width: 43%;
  height: 100%;
  background-color: white;
  border-radius: 11px;
  box-shadow: 0 0 4.4px 0 rgba(0, 0, 0, 0.08);
`;
const RightSideWrapper = styled.div`
  width:57%;
  height: 100%;
  background-color: white;
  border-radius: 11px;
  box-shadow: 0 0 4.4px 0 rgba(0, 0, 0, 0.08);

  display: flex;     /* ✅ 내부 섹션이 높이 채우게 */
  min-width: 0;
  min-height: 0;     /* ✅ flex 내부 스크롤 필수 */
  overflow: hidden;  /* ✅ 스크롤은 내부로 넘김(아래 RightSection에서) */
`;

const AdTeamPage = () => {
  return (
    <>
    <PageWrapper>
        <LeftSideWrapper>
            <LeftSection/>
        </LeftSideWrapper>
        <RightSideWrapper>
            <RightSection/>
        </RightSideWrapper>
    </PageWrapper>
    </>
  )
}

export default AdTeamPage